export const whatsAppMixin = {
    mixins: [],
    props: {
    },
    data: function () {
        return {
            whatsAppBusiness: null
        }
    },
    computed: {
        isWhatsAppInitiated: function() {
            return this.whatsAppBusiness && this.whatsAppBusiness.status === "initiated";
        },
        isWhatsAppSigningUp: function() {
            return this.whatsAppBusiness && this.whatsAppBusiness.status === "signing-up";
        },
        isWhatsAppActive: function() {
            return this.whatsAppBusiness && this.whatsAppBusiness.status === "active";
        },
    },
    methods: {
        fetchWhatsApp: async function (establishmentReference) {
            this.loading = true;
            this.error = false;
            try {
                let response = await this.$http.get('/guest-management/v1/establishments/' + establishmentReference + '/whatsapp');
                this.whatsAppBusiness = response.data;
                console.log(response);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.whatsAppBusiness = null;
                    return;
                }
                this.error = true;
                if (error.response) {
                    this.infoMessage = error.response.data.message
                } else {
                    this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                }
            } finally {
                this.loading = false
            }
        },
    },
}